import {useCookie} from '@aboutyou/storage';
import {exists, RECOMMENDED_SIZES_COOKIE_KEY} from '@aboutyou/utils';

type RecommendedSize = {id: number; size: string};

const transformCookieRawValue = JSON.parse.bind(JSON);

export const useRecommendedSizesCookie = () => {
  const [recommendedSizes, setRecommendedSizes] = useCookie<
    RecommendedSize[] | null
  >({
    cookieName: RECOMMENDED_SIZES_COOKIE_KEY,
    defaultValue: null,
    transformRawValue: transformCookieRawValue,
  });

  /*
   * We saw errors originating from recommendedSizes being truthy but not an array
   */
  const sanitizedRecommendedSizes =
    recommendedSizes && !Array.isArray(recommendedSizes)
      ? []
      : recommendedSizes;

  const updateRecommendedSizes = ({id, size}: RecommendedSize) => {
    if (!sanitizedRecommendedSizes) {
      setRecommendedSizes([{id, size}]);

      return;
    }

    const index = getIndexById(sanitizedRecommendedSizes, id);

    const updatedRecommendations = (
      exists(index)
        ? [
            ...sanitizedRecommendedSizes.slice(0, index),
            {...sanitizedRecommendedSizes[index], size},
            ...sanitizedRecommendedSizes.slice(index + 1),
          ]
        : [...sanitizedRecommendedSizes, {id, size}]
    ) as RecommendedSize[];

    setRecommendedSizes(updatedRecommendations);

    return null;
  };

  return {recommendedSizes: sanitizedRecommendedSizes, updateRecommendedSizes};
};

const getIndexById = (recommendations: RecommendedSize[], id: number) => {
  const reco = recommendations.find(reco => reco.id === id);
  const idx = reco ? recommendations.indexOf(reco) : -1;

  return idx === -1 ? null : idx;
};
